import { render, staticRenderFns } from "./open-auth-token.vue?vue&type=template&id=756c5d38&scoped=true&"
import script from "./open-auth-token.vue?vue&type=script&lang=js&"
export * from "./open-auth-token.vue?vue&type=script&lang=js&"
import style0 from "./open-auth-token.vue?vue&type=style&index=0&id=756c5d38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c5d38",
  null
  
)

export default component.exports